module.exports = __webpack_public_path__ + "img/borders2.0fd4a85d.png";